import React from "react";
import { Radar } from "react-chartjs-2";
import PropTypes from "prop-types";

// const options = {
//     scale: {
//         ticks: {
//             beginAtZero: true,
//             min: 0,
//             max: 10,
//             stepSize: 5
//         },
//         pointLabels: {
//             fontSize: 10,
//             fontColor: "#666",
//             fontFamily: "'Arial', 'Helvetica', 'Helvetica Neue', sans-serif"
//         }
//     },
//     legend: {
//         display: true,
//         position: "bottom",
//         labels: {
//             usePointStyle: true,
//             fontColor: "#444",
//             fontStyle: "bold",
//             fontSize: 13,
//             boxWidth: 5,
//             fontFamily: "'Arial', 'Helvetica', 'Helvetica Neue', sans-serif",
//             padding: 30
//         }
//     }
// };

const options = {
  scale: {
    ticks: {
      beginAtZero: true,
      min: 0,
      max: 10,
      stepSize: 5
    },
    pointLabels: {
      fontSize: 12,
      fontColor: "#666",
      fontFamily: "'Arial', 'Helvetica', 'Helvetica Neue', sans-serif"
    }
  },
  legend: {
    display: true,
    position: "bottom",
    labels: {
      usePointStyle: true,
      fontColor: "#444",
      fontStyle: "bold",
      fontSize: 13,
      boxWidth: 6,
      fontFamily: "'Arial', 'Helvetica', 'Helvetica Neue', sans-serif",
      padding: 42
    }
  }
};

const OverallPerformanceChart = ({ data }) => {
  return <Radar data={data} options={options} height={40} width={100} />;
};

OverallPerformanceChart.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired
};

export default OverallPerformanceChart;
